import { render, staticRenderFns } from "./ArrobaMedellinHorizontalCard.html?vue&type=template&id=4dcd97b8&scoped=true&external"
import script from "./ArrobaMedellinHorizontalCard.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinHorizontalCard.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinHorizontalCard.scss?vue&type=style&index=0&id=4dcd97b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd97b8",
  null
  
)

export default component.exports